import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { CDN_LINK } from "@globalConfig";
import PaymentInfo from "@/pages/checkout/components/PaymentInfo/PaymentInfo";
import stl from "./MobileCarInfo.module.css";
import { useTranslation } from "@i18n";
import CarInfoShimmer from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/CarInfoShimmer";
import useBoolean from "@hooks/useBoolean";
var MobileCarInfo = function MobileCarInfo(_ref) {
  var _checkoutOrder$custom;
  var hasImg = _ref.hasImg,
    checkoutOrder = _ref.checkoutOrder,
    hideData = _ref.hideData,
    remaining = _ref.remaining,
    financeRemainingOrder = _ref.financeRemainingOrder,
    hideTitle = _ref.hideTitle,
    className = _ref.className,
    onClickInfoIcon = _ref.onClickInfoIcon;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    slideMe = _useState[0],
    setSlideMe = _useState[1];
  var allInfoPopup = useBoolean();
  var finalClassName = [stl.container, className || undefined, hasImg ? stl.hasImg : ""].join(" ");
  if (!checkoutOrder) return /*#__PURE__*/React.createElement("div", {
    className: finalClassName
  }, " ", /*#__PURE__*/React.createElement(CarInfoShimmer, null));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: finalClassName
  }, !remaining && !financeRemainingOrder && !hideTitle && /*#__PURE__*/React.createElement("strong", null, checkoutOrder.post_title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(!financeRemainingOrder ? stl.smallContainer : stl.fullWidth)
  }, !remaining ? financeRemainingOrder ? /*#__PURE__*/React.createElement("div", {
    className: stl.header
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.customerDetails
  }, /*#__PURE__*/React.createElement("h3", null, t("أهلاً,", {
    ns: "web_common"
  }), " ", financeRemainingOrder ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.customer_name : (_checkoutOrder$custom = checkoutOrder.customer) === null || _checkoutOrder$custom === void 0 ? void 0 : _checkoutOrder$custom.name), /*#__PURE__*/React.createElement("p", null, t("رقم الطلب", {
    ns: "web_common"
  }), /*#__PURE__*/React.createElement("span", null, financeRemainingOrder ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.order_id : checkoutOrder.id))), /*#__PURE__*/React.createElement("div", {
    className: stl.orderDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.postTitle
  }, /*#__PURE__*/React.createElement("p", null, t("قيمة الخدمات المضافة على:", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_title)), /*#__PURE__*/React.createElement("div", {
    className: [stl.methodHeader, stl.paymentData].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.gray
  }, /*#__PURE__*/React.createElement("p", null, t("المبلغ المدفوع", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("strong", null, " ", financeRemainingOrder ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.paid_amount : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.payed_amount, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_common"
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("المبلغ المتبقي", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("strong", null, financeRemainingOrder ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.remaining_amount : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.remaining_price_payed, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_common"
  }))))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.title
  }, t("المبلغ الإجمالي", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    className: stl.price
  }, checkoutOrder.total_price, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  })))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.title
  }, t("عربون من قيمة السيارة", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    className: [stl.price, stl.greenPrice].join(" ")
  }, checkoutOrder.arboun, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.mostarda
  }, t("مستردة", {
    ns: "web_checkout_cash"
  }))))) : /*#__PURE__*/React.createElement("div", {
    className: [stl.flx, stl.remaining].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, checkoutOrder.post_title), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, t("رقم الطلب", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder.id)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, t("المبلغ المتبقي", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.pricing
  }, /*#__PURE__*/React.createElement("strong", null, checkoutOrder.remaining_price_payed), t("ريال", {
    ns: "web_checkout_cash"
  })))), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setSlideMe(true);
      allInfoPopup.setTrue();
    },
    className: stl.togglInfo
  }, t("إعرض التفاصيل", {
    ns: "web_checkout_cash"
  })))), allInfoPopup.value && /*#__PURE__*/React.createElement("div", {
    className: stl.fixedContainer,
    onClick: function onClick(e) {
      if (e.target === e.currentTarget) allInfoPopup.setFalse();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.subContFixed, financeRemainingOrder ? stl.smallerPopUp : "", slideMe ? stl.open : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.hdr
  }, /*#__PURE__*/React.createElement("strong", null, t("تفاصيل الدفع", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("img", {
    className: "hasEvents",
    onClick: allInfoPopup.setFalse,
    width: "15px",
    height: "15px",
    src: CDN_LINK + "/assets/images/close_gry.svg",
    alt: "close"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.bodyIn
  }, /*#__PURE__*/React.createElement(PaymentInfo, {
    loading: false,
    checkoutOrder: checkoutOrder,
    hideData: hideData,
    financeRemainingOrder: financeRemainingOrder,
    onClickInfoIcon: onClickInfoIcon
  })))));
};
export default MobileCarInfo;